var first_coll=$(".grid__item.first_coll").attr("data-variant-id");
$(".buy_now_btn").attr("value",first_coll);
let rawText = $(".grid__item.first_coll .card-information span.price-item.price-item--regular").text();
let cleanedText = rawText
.replace(/[\n\r\t]+/g, ' ')
.replace(/\s+/g, ' ')
.trim();
$(".price.regula_coll_data .price__container").text(cleanedText);
$(".product_list_data li.grid__item").click(function() {
// Add active class to clicked li and remove from others
$(".product_list_data li.grid__item").removeClass("active");
$(this).addClass("active");
// Update value from data-variant-id
var idda = $(this).attr("data-variant-id");
$(".buy_now_btn").attr("value", idda);
// Clean and update price
let rawText = $(this).find(".card-information span.price-item.price-item--regular").text();
let cleanedText = rawText
.replace(/[\n\r\t]+/g, ' ')
.replace(/\s+/g, ' ')
.trim();

$(".price.regula_coll_data .price__container").text(cleanedText);


var desclik= $(this).find(".product_decrption_coll.hide").html();
$(".discreption_dKL .KL_data-tab-text").html(desclik);
});
// Add to cart
document.querySelectorAll('.custom-add-to-cart-form').forEach(form => {
form.addEventListener('submit', function(e) {
e.preventDefault();

const productId = form.querySelector('button.buy_now_btn').value;

const formData = new FormData(this);
const data = {
items: [
{
id: productId,
quantity: 1,
properties: {}
}
]
};

// Add custom properties from the form
for (let [key, value] of formData.entries()) {
if (key.startsWith('properties[')) {
const propKey = key.replace('properties[', '').replace(']', '');
data.items[0].properties[propKey] = value;
}
}
fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
'Accept': 'application/json'
},
body: JSON.stringify(data)
})
.then(res => {
if (!res.ok) throw new Error('Add to cart failed');
return res.json();
})
.then(response => {

$.ajax({
url: '/?section_id=cart-drawer',
type: 'GET',
dataType: 'html',
success: function (carthtml) {
const newCartDrawer = $(carthtml).find('cart-drawer');

if (newCartDrawer.length) {
const oldCartDrawer = document.querySelector('cart-drawer');

if (oldCartDrawer) {
oldCartDrawer.replaceWith(newCartDrawer[0]); 
newCartDrawer[0].setAttribute('open', true); 
document.querySelector('#cart-icon-bubble')?.click();
}
}
}
});


})
.catch(err => {

});
});
});
setInterval(function () {
jQuery.getJSON('/cart.js', function(cart) {
jQuery(".number_counts").html(cart.item_count);
$("#cart-icon-bubble span.visually-hidden").html(cart.item_count);
});
}, 200);
// discreption

var descreption= $("li.grid__item.first_coll.active span.product_decrption_coll.hide").html();
$(".discreption_dKL .KL_data-tab-text").html(descreption);
// Buy now data
document.querySelectorAll('.buy-now-button').forEach(button => {
    button.addEventListener('click', function () {
      const inputs = [
        document.getElementById('user_id'),
        document.getElementById('zone_id')
      ];
      let allValid = true;

      for (const input of inputs) {
        const isRequired = input.hasAttribute('required');
        const isEmpty = input.value.trim() === '';

        if (isRequired && isEmpty) {
          alert(`${input.id} is blank. Please enter all required fields.`);
          allValid = false;
          break; // Stop checking after the first missing field
        }
      }

      if (allValid) {
        setTimeout(() => {
          window.location.href = '/checkout';
        }, 1500);
      }
    });
  });
// shwo hide file on collection page:

function checkXenogemsActiveItem(elem) {
  if ($(elem).hasClass("Xenogems1")) {
    // Show user ID section and make required
    $("p.user_id_main_data").show();
    $("#user_id").attr("required", "required");

    // Show other sections and make zone ID required
    $(".service_id_datestls").show();
    $(".autocomplete-container").show();
    $("p.rememeberdata_main").show();
    $("#zone_id").attr("required", "required");
  } else {
    // Hide user ID section, remove required, and clear value
    $("p.user_id_main_data").hide();
    $("#user_id").removeAttr("required").val("");

    // Hide other sections, remove required from zone ID, and clear value
    $(".service_id_datestls").hide();
    $(".autocomplete-container").hide();
    $("p.rememeberdata_main").hide();
    $("#zone_id").removeAttr("required").val("");
  }
}

$(document).ready(function () {
  // Initial check on page load
  const initialItem = $("li.grid__item.first_coll.active");
  if (initialItem.length) {
    checkXenogemsActiveItem(initialItem);
  }

  // On click of any product item
  $(".product_list_data ul#product-grid li.grid__item").click(function () {
    $(".product_list_data ul#product-grid li.grid__item").removeClass("active");
    $(this).addClass("active");
    checkXenogemsActiveItem(this);

    var v_data = $(this).find(".Kloc_colle.product-card.hide .inner_data_varints").html();
    $(".varint_data_customs").html(v_data);
  });
});

// new js for quick
document.addEventListener('DOMContentLoaded', function () {
function validateInputs(modal) {
const zoneInput = modal.querySelector('#zone_id');
const userInput = modal.querySelector('#user_id');
const payButton = modal.querySelector('.shopify-payment-button');

if (zoneInput && userInput && payButton) {
const allFilled = zoneInput.value.trim() !== '' && userInput.value.trim() !== '';
payButton.style.pointerEvents = allFilled ? 'auto' : 'none';
payButton.style.opacity = allFilled ? '1' : '0.5';
}
}
document.body.addEventListener('input', function (event) {
const modal = event.target.closest('.quick-add-modal__content-info');
if (modal) {
validateInputs(modal);
}
});
document.body.addEventListener('click', function (event) {
if (event.target.matches('[data-open-quick-view]')) {
setTimeout(() => {
    const modal = document.querySelector('.quick-add-modal__content-info');
    if (modal) {
        validateInputs(modal);
    }
}, 100);
}
});
});

// 22/05/Buy now


